module.exports = {
    'app.report.user.error.server.msg': "Có lỗi xảy ra",
}